export interface CookiePreferences {
  analytics: boolean;
  functional: boolean;
  timestamp: number;
}

const CONSENT_KEY = 'bbz-cookie-consent';
const CONSENT_DURATION = 13 * 30 * 24 * 60 * 60 * 1000; // 13 mois en millisecondes

export const getCookieConsent = (): CookiePreferences | null => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    
    const preferences = JSON.parse(stored) as CookiePreferences;
    
    // Vérifier si le consentement est expiré
    if (isConsentExpired(preferences.timestamp)) {
      clearCookieConsent();
      return null;
    }
    
    return preferences;
  } catch {
    return null;
  }
};

export const setCookieConsent = (preferences: Partial<CookiePreferences>): void => {
  const fullPreferences: CookiePreferences = {
    analytics: preferences.analytics ?? false,
    functional: true, // Toujours true (cookies essentiels)
    timestamp: Date.now(),
  };
  
  localStorage.setItem(CONSENT_KEY, JSON.stringify(fullPreferences));
  
  // Émettre un événement personnalisé pour notifier les changements
  window.dispatchEvent(new CustomEvent('cookieConsentUpdated', { 
    detail: fullPreferences 
  }));
};

export const isConsentExpired = (timestamp?: number): boolean => {
  if (!timestamp) return true;
  return Date.now() - timestamp > CONSENT_DURATION;
};

export const clearCookieConsent = (): void => {
  localStorage.removeItem(CONSENT_KEY);
  window.dispatchEvent(new CustomEvent('cookieConsentCleared'));
};

export const acceptAllCookies = (): void => {
  setCookieConsent({ analytics: true });
};

export const rejectAllCookies = (): void => {
  setCookieConsent({ analytics: false });
};
